import React from 'react';

interface Props {
  readonly label: string;
  readonly sortKeyName: string;
  readonly activeSortKey: string | undefined;
  readonly sortDirection: 'asc' | 'desc';
  readonly onSort: (key: string) => void;
  readonly className?: string;
}

const SortableHeaderCell = ({ label, sortKeyName, activeSortKey, sortDirection, onSort, className }: Props): React.JSX.Element => {
  const active = activeSortKey === sortKeyName;

  let indicator = '⇅';
  if (active) {
    indicator = sortDirection === 'asc' ? '▲' : '▼';
  }

  return (
    <th
      className={className}
      role="button"
      tabIndex={0}
      onClick={(): void => onSort(sortKeyName)}
      onKeyDown={(event): void => {
        if (event.key === 'Enter' || event.key === ' ') {
          onSort(sortKeyName);
        }
      }}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
    >
      {label}
      <span style={{ marginLeft: 4, opacity: active ? 1 : 0.35, fontSize: '0.85em' }}>{indicator}</span>
    </th>
  );
};

export default SortableHeaderCell;
